import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { SharedService } from '../services/shared.service';
import { ProfileService } from '../services/profile/profile.service';

import * as amplitude from 'amplitude-js';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  amplitudeCompensar: amplitude = null;
  trackEvents: boolean = null;
  apiKeyAmplitude: string = '';

  amplitudeInitialized: boolean = false;

  endPointClientIp: string = environment.endPointMicroApi;

  constructor(
    private _http: HttpClient,
    private _profileService: ProfileService,
    private _sharedService: SharedService
  ) {
    this.getIpOrPhone();
  }

  async getIpOrPhone() {
    if(this._sharedService.validSession()){
      this.getInfoUser();
    }else{
      this.getIpUser();
    }
  }

  async getIpUser() {
    let response: any = await this._http.get(`${this.endPointClientIp}/user-ip.php`).toPromise();
    if(response && response.user_ip){
      localStorage.setItem('user_ip', response.user_ip);
      this.initAmplitude();
    } else localStorage.setItem('user_ip', '000');
  }


  async getInfoUser() {
    let response: any = await this._profileService.getDataUser().toPromise()
      .catch((err: any) => {
        console.log('Error al obtener el historial');
      });
    if( response && response.data && response.data.usuario ){
      localStorage.setItem('user_phone', `${response.data.usuario.phone_code}${response.data.usuario.phone}`);
      this.initAmplitude();
    }
  }

  initAmplitude(): void {
    
    this.trackEvents = environment.trackEventAmplitude;
    this.apiKeyAmplitude = environment.apiKeyAmplitude;
    this.amplitudeCompensar = amplitude.getInstance();
    
    let user_id = localStorage.getItem('user_phone') && localStorage.getItem('user_phone') != 'undefined' ? localStorage.getItem('user_phone') : localStorage.getItem('user_ip');

    this.amplitudeCompensar.init(this.apiKeyAmplitude, user_id);
  }

  emmiterLogEvent(nameEvent: string, parameters: any): void {
    
    if(this.trackEvents) this.trackEvent(nameEvent, parameters);
  
  }

  trackEvent(nameEvent: any, parameters: any): void {

    parameters.USER_ID        ? null : parameters.USER_ID        = localStorage.getItem('uid')   ? localStorage.getItem('uid') : '000';
    parameters.USER_TOKEN     ? null : parameters.USER_TOKEN     = localStorage.getItem('token') ? localStorage.getItem('token') : 'Sin token';
    
    if(parameters.USER_ID){
      this.amplitudeCompensar.logEvent(nameEvent, parameters);
    }else console.log('Falta "user_id" y/o "user_name" para amplitude.');

  }

}
// 1015463696